<template>
<v-container fluid class="fill-height" style="background:#fafafa;">
    <!-- Ensure full height and specified background -->
    <v-row justify="center" align="center" style="background:#fafafa;">
        <!-- Center content horizontally and vertically -->
        <v-col cols="12" sm="12" md="12" class="mAuto">
            <!-- Adjust column sizes as needed -->
            <v-card v-if="loading" :loading="loading">
               
 
                <v-card-text>
                </v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-title :style="[{ color: form.title_color },{ fontSize: form.title_font_size+'px' }]">
                   <div class="text-center"> {{ form.title }} </div>
                </v-card-title>
                <v-card-text>
                    <v-radio-group v-model="selectedOffer">
                            <v-card elevation="2" style="padding: 20px; margin-top: 20px;"
                                    v-for="offer in formOffersFormatted" :key="offer.id" variant="outlined">
                                <v-radio :value="offer.id" color="primary">
                                    <template v-slot:label>
                                        <div class="radio-label">{{ offer.label }}</div>
                                    </template>
                                </v-radio>
                            </v-card>
                        </v-radio-group>

                    <!-- <v-form @submit.prevent="onSubmit"> -->
                        <v-row v-for="field in form.fields" :key="field.id">
                            <v-col cols="12">
                                <!-- Name Field -->
                                <v-text-field v-if="field.field_type === 'Name'" v-model="fields[field.id]" :label="field.label" :rules="[v => !!v || 'Field is required']" outlined required>
                                </v-text-field>

                                <!-- Phone Number Fields -->
                                <v-text-field v-else-if="field.field_type === 'FIRST_NUMBER_PHONE' || field.field_type === 'SECOND_NUMBER_PHONE'" type="number" v-model="fields[field.id]" :label="field.label" :rules="[v => !!v || 'Field is required']" outlined required>
                                </v-text-field>

                                <!-- Country Field -->
                                <v-autocomplete v-else-if="field.field_type === 'COUNTRY'" :items="countries" item-text="name" item-value="id" v-model="fields[field.id]" :label="`Select ${field.label}`" outlined></v-autocomplete>

                                <!-- City Field -->
                                <v-autocomplete v-else-if="field.field_type === 'CITY'" :items="cities" item-text="name" item-value="id" v-model="fields[field.id]" :label="`Select ${field.label}`" outlined></v-autocomplete>

                                <!-- Address Field -->
                                <v-textarea v-else-if="field.field_type === 'ADDRESS'" v-model="fields[field.id]" :label="field.label" :rules="[v => !!v || 'Field is required']" outlined required>
                                </v-textarea>
                            </v-col>
                        </v-row>

                        <!-- Offers -->
                        <!-- <v-radio-group v-if="form.form_offers && form.form_offers.length > 0" v-model="selectedOffer" label="Choose an Offer" outlined required>
                            <v-radio v-for="offer in formOffersFormatted" :key="offer.id" :label="offer.offerText" :value="offer.id"></v-radio>
                        </v-radio-group> -->
                

                        <v-btn block size="x-large" type="submit" :style="[{backgroundColor:form.primary_color},{color: form.button_font_color}]"       >{{ form.submit_label }}</v-btn>
                    <!-- </v-form> -->
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
// import axios from 'axios';

export default {
    props: ['formUuid'],
    data() {
        return {
            loading:true,
            form: {
                fields: [],
                primaryColor: '',
                title: '',
                form_offers: [],
            },
            fields: {},
            selectedOffer: null,
            countries: [], // This should be fetched or passed as a prop
            cities: [] ,// This should be fetched or passed as a prop
            formOffers: [], // Make sure to define formOffers here

        };
    },
    watch: {
        // Watch the formUuid prop for changes
        formUuid: {
            handler(newUuid, oldUuid) {
                if(newUuid !== oldUuid) {
                    this.fetchFormData();
                }
            },
            immediate: true // This ensures the watcher is triggered immediately upon component creation
        }
    },
    methods: {
        async fetchFormData() {
    try {
        const payload = {
            resource: `/previewForm/${this.formUuid}`, // Assuming this is the correct resource path
        };
        const response = await this.$store.dispatch('getResource', payload);
        this.form = response.data.form;
        this.countries = response.data.countries;
        this.cities = response.data.cities;
        this.formOffers = this.form.form_offers; // Set formOffers here

        console.log("Form data fetched", this.form);
    } catch (error) {
        this.error = true; // Handle errors
        console.error("Error fetching form data:", error);
    } finally {
        this.loading = false;
    }
},
        onSubmit() {
            // Your existing onSubmit method
        },
    },
    computed: {
    formOffersFormatted() {
        return this.form.form_offers.map(offer => ({
            id: offer.id,
            label: `${offer.label}`
        }));
    }
},
    language() {
        return this.$store.state.language;
    },
    i18n() {
        return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
        if (this.$store.state.language == "ar")
            return true;
    },
};
</script>


<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

.centered-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* This makes the container take the full viewport height */
}

.custom-btn {
  transition: background-color 0.3s, color 0.3s; /* Smooth transition for hover effect */
}

.custom-btn:hover {
  background-color: #fffffffa; /* Change to your hover background color */
  color: #000000; /* Change to your hover font color */
}
</style>